import React from "react";
import { Stack } from "@mui/material";
import { MENUS } from "../../../../../utils/ui.constants";
import SidebarItemIcon from "./SidebarItemIcon";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { allowShowAuthorize } from "../../../../../utils/helpers";

function SidebarSmall() {
  const location = useLocation();
  const { profile, rights } = useSelector((state: any) => state.auth);

  return (
    <Stack sx={{ width: "100%", px: 2 }}>
      {MENUS.map((menu, i) => {
        const items = menu.items || [];
        const show =
          menu.show ||
          profile?.admin_app ||
          allowShowAuthorize({
            module: menu.items
              ? menu.items.map((item) => item.module)
              : menu.module || "",
            rights: rights || [],
          });
        if (!show) return null;
        return (
          <React.Fragment key={i}>
            {items.map((item, j) => {
              let active = item.path === "/" && location.pathname === "/";
              if (item.path && item.path !== "/") {
                active = location.pathname.includes(item.path);
              }
              const show =
                profile?.admin_app ||
                allowShowAuthorize({
                  rights: rights || [],
                  module: item.module,
                });
              if (!show) return null;
              return (
                <SidebarItemIcon
                  key={j}
                  text={item.text}
                  Icon={item.Icon}
                  href={item.path}
                  active={active}
                />
              );
            })}
          </React.Fragment>
        );
      })}
    </Stack>
  );
}

export default SidebarSmall;
